import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { Download } from 'lucide-react';
import { useExportTxt } from '@/hooks/use-export-txt';

export function DownloadPolicies({
	fileData,
}: {
	fileData: string;
}) {
	const [isLoading, setIsLoading] = useState(false);

	//use export txt hook to convert fileData to txt and download
	const { exportToTxt } = useExportTxt();

	const handleDownload = () => {
		setIsLoading(true);
		exportToTxt(fileData, 'Blackline_Download.txt');
		setIsLoading(false);
	};

	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						className="m-auto"
						variant="ghost"
						onClick={handleDownload}
						disabled={isLoading}
					>
						<Download size={16} />
					</Button>
				</TooltipTrigger>
				<TooltipContent>
					<span>Download file</span>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
